import React from 'react';
import { Typography } from 'antd';
import * as styles from '@styles/pageNotFound.module.scss'; 

const { Title, Paragraph } = Typography;

const PageNotFound: React.FC = () => {

  return (
    <div className={styles.container} >
      <Title level={1} style={{ fontSize: '48px' }}>401</Title>
      <Paragraph style={{ fontSize: '18px', marginBottom: '20px' }}>
        Sorry you don't have access.
      </Paragraph>
    </div>
  );
};

export default PageNotFound;
